import(/* webpackMode: "eager" */ "/app/src/app/about/join/page.tsx");
